import ContentView from "Components/ContentView/ContentView";
import * as React from "react";
import styles from "./ChecklistTemplateBlockOverview.scss";
import ChecklistTemplateBlockOverviewHeader from "./ChecklistTemplateBlockOverviewHeader/ChecklistTemplateBlockOverviewHeader";
import ChecklistTemplateBlockView from "./ChecklistTemplateBlockView/ChecklistTemplateBlockView";
import ChecklistTemplateFilters from "./ChecklistTemplateFilters/ChecklistTemplateFilters";
import ChecklistTemplateSearch from "./ChecklistTemplateSearch/ChecklistTemplateSearch";

const ChecklistTemplateBlockOverview: React.FunctionComponent<{}> = () => (
    <ContentView>
        <ChecklistTemplateBlockOverviewHeader />
        <ChecklistTemplateSearch />
        <div className={styles.flexWrapper}>
            <ChecklistTemplateFilters />
            <ChecklistTemplateBlockView />
        </div>
    </ContentView>
);

export default ChecklistTemplateBlockOverview;


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockOverview.tsx